// api.js
import axios from "axios";

const api = axios.create({
    baseURL: 'https://aydeesbackend.aydees.com',
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    },
  
});

export default api;
//https://aydeesbackend.aydees.com/